export const parseBinaryIoValue = (value) => {
  if (value === undefined || value === null || value === '') return null;
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value > 0;
  const normalized = String(value).trim().toLowerCase();
  if (['1', 'true', 'on', 'yes', 'recording', 'active'].includes(normalized)) return true;
  if (['0', 'false', 'off', 'no', 'idle', 'inactive', 'not_recording'].includes(normalized)) return false;
  const numeric = Number(normalized);
  return Number.isFinite(numeric) ? numeric > 0 : null;
};

export const getCameraRecordingIoValue = (io, channel) => {
  if (!io) return null;
  const keys = [
    `cam_rec_ch${channel}`,
    `camera_rec_ch${channel}`,
    `camera_recording_ch${channel}`,
    `cam_recording_ch${channel}`,
    `ch${channel}_recording`,
    `camera${channel}_recording`,
  ];
  const lowerKeyMap = Object.keys(io).reduce((acc, key) => {
    acc[String(key).toLowerCase()] = key;
    return acc;
  }, {});
  for (const key of keys) {
    const actualKey = lowerKeyMap[key.toLowerCase()];
    if (actualKey !== undefined) return parseBinaryIoValue(io[actualKey]);
  }
  return null;
};

export const getConfiguredCameraCount = (device) => {
  const count = Number(device?.total_cameras ?? device?.num_cameras ?? 1);
  return Number.isFinite(count) && count > 0 ? Math.floor(count) : 1;
};

export const getCameraRecordingState = (device) => {
  const totalChannels = getConfiguredCameraCount(device);
  const channels = Array.from({ length: totalChannels }, (_, i) => i + 1);
  const io = device?.last_io_elements || device?.last_io || {};
  const explicitStates = channels.map((channel) => getCameraRecordingIoValue(io, channel));
  const knownStates = explicitStates.filter((state) => state !== null);
  const missingFallback = knownStates.length > 0 ? knownStates.some(Boolean) : false;
  const recordingByChannel = channels.reduce((acc, channel, index) => {
    const explicit = explicitStates[index];
    acc[channel] = explicit === null ? missingFallback : explicit;
    return acc;
  }, {});
  const isGprsOnline = typeof device?.is_online === 'boolean'
    ? device.is_online
    : device?.status !== 'offline';
  const hasAnyRecording = isGprsOnline && channels.some((channel) => recordingByChannel[channel]);
  return { isGprsOnline, hasAnyRecording, recordingByChannel };
};